











































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { SwModal } from '@libs-uuif/shared/sw-modal';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { InfoState } from '@/core';

const cssPrefix = 'star-rating-component';

@Component({
  components: {
    SwModal,
    SwTextarea,
    SwForm,
    SwButton,
    SwFormRow,
  },
})
export default class StarRatingComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;
  stars: boolean[] = [];
  @Prop() showFeedBackDialog: boolean;
  locked: boolean = false;
  checkedStar: number = -1;
  saySomethingGoodPlease: string = '';

  created() {
    for (let i:any = 0; i < 5; i += 1) { this.stars.push(false); }
    this.$store.dispatch('stopLoading');
  }

  ratingEmotion() {
    const ratingEmotionList: string[] = [
      'Let us',
    ];
    return ratingEmotionList;
  }

  hasRatedYet() {
    return (this.checkedStar + 1) > 0 ? `Please elaborate why you rated ${(this.checkedStar + 1)} here (optional)` :'Please rate to comment';
  }

  closeDialog() {
    this.$emit('closeDialog');
  }

  reset() {
    for (let i = 0; i < 5; i += 1) {
      i <= this.checkedStar ? this.$set(this.stars, i, true) : this.$set(this.stars, i, false);
    }
  }

  hoverFunction(hoveredStar: number) {
    for (let i = 0; i < 5; i += 1) {
      i <= hoveredStar ? this.$set(this.stars, i, true) : this.$set(this.stars, i, false);
    }
  }

  onSelect(selectedStar: number) {
    this.checkedStar = selectedStar;
  }

  getScreenName() {
    const screenNameList = new Map<string, string>();
    let screenName: string | undefined;
    screenNameList.set('dashboard', 'My Workspace');
    screenNameList.set('register-products', 'Register Products');
    screenNameList.set('user-groups', 'User Groups');
    // tslint:disable-next-line:no-unused
    screenNameList.forEach((value, key) => {
      if (window.location.pathname.indexOf(key) > 0) screenName = screenNameList.get(key);
    });

    return screenName ? screenName : 'Tenant Products';
  }

  submitRating() {
    this.$store.dispatch('sendFeedback', {
      stars: (this.checkedStar + 1),
      comment: this.saySomethingGoodPlease,
      screenName: this.getScreenName(),
    })
    .then((result: any) => {
      const message: InfoState = { infoType: result.operationStatus === 'OK' ? 'success' : 'failed', infoMsg: result.operationStatus === 'OK' ?
      'Thank you, we really appreciate your feedback' : result.msgDesc };
      this.$store.commit('enqueueMessage', message);
      this.$store.commit('stopLoading');
      this.closeDialog();
    });
  }
}
